import {ReactNode} from "react";

export interface PageTitleProps {
    children: ReactNode
}

export function PageTitle(props: PageTitleProps) {
    return <h1 className="text-3xl font-fira-sans font-semibold leading-snug">{props.children}</h1>
}